'use strict';
import {assignUserToModel, assignUserProfileToModel} from '../actions';

const initialState = null;
export function user(state = initialState, action) {
  switch (action.type) {
    case assignUserToModel.TYPE:
      return action.payload.user;
    default:
      return state;
  }
}

export function userProfile(state = initialState, action) {
  switch (action.type) {
    case assignUserProfileToModel.TYPE:
      return action.payload.userProfile;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/app/model/reducers/modelUser.js